module.exports = __webpack_public_path__ + "0afdb5b95c4e761e9a02702dbdbd33d3.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/lato/lato-light-webfont.woff
 ** module id = ./src/styles/fonts/lato/lato-light-webfont.woff
 ** module chunks = 0
 **/